
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import tipos from './lista-buscador-tipos.vue';
    import { ControladorSeccion } from '@/views/a-estadisticas-diaria/pc/lista/controlador';
    import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            tipos,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }

        public Buscar( forzar?: boolean )
        {
            this.Buscador.Buscar( 1 );
        }


    }
